// extracted by mini-css-extract-plugin
module.exports = {"appliedFilters":"_30fpi","appliedFilterText":"_1eMut"};